<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent max-width="400" id="logoutDialog">
      <v-card class="pa-6">
        <v-card-text class="text-center pb-10">
          <span class="subtitle-1 black--text">
            Вы уверены что хотите выйти,
          </span>
          <span class="title black--text">{{ name }}</span>
        </v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer />
          <v-btn outlined rounded large color="grey darken-1" class="text-capitalize px-4 mr-2" @click="cancelHandler">
            Отменить
          </v-btn>
          <v-btn id="logoutBtn" rounded large color="primary" class="text-capitalize px-8 ml-2" @click="logoutHandler">
            Выйти
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'LogoutModal',
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true
    },
    name: {
      type: String,
      default: ''
    }
  },
  methods: {
    cancelHandler() {
      this.$emit('close-logout-modal')
    },
    logoutHandler() {
      this.$emit('set-logout')
    }
  }
}
</script>
